import martinPic from "@/public/images/artists/martin.png";
import { Artist } from "@/types/types";

export const martin = {
  id: "233",
  name: "Martin",
  image: martinPic,
  description: `Martin's voice has a rugged, untamed quality that cuts through the music, with a rich vibrato that shines in his belting. Moving effortlessly from intimate to anthemic, his voice suits both emotive 80s ballads and high-energy dance anthems.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmartin-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Pop",
        "Dance",
        "Disco",
        "RnB",
        "Belting",
        "Unprocessed",
        "Rock",
      ],
      secondary: ["80s"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 64,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
